import { createRouter, createWebHistory } from 'vue-router';
import { isMiniProgram, queryStringify } from 'cfmoto-utils';
import beforeEach from './beforeEach';
import store from '../store';
import { SET_TITLE } from '../store/mutationTypes';
import { APP_LANGS } from '../constants';
import getLanguage from '@/utils/setLanguage';

const requireModules = require.context('./modules', true, /(.js$)/);
const routes = requireModules
  .keys()
  .map((filePath) => requireModules(filePath).default)
  .flat();

const router = createRouter({
  scrollBehavior(to, from, savedPosition) {
    return savedPosition || { x: 0, y: 0 };
  },
  history: createWebHistory('/app'),
  routes,
});

beforeEach.forEach((item) => {
  router.beforeEach(item).bind(router);
});

// 路由切换成功
router.afterEach((route) => {
  try {
    console.log('afterEach');
    // 优先取参数传进来的语言
    let { queryLocale, navigatorLanguage } = getLanguage(route.query.locale);
    const language = queryLocale || JSON.parse(window.localStorage.getItem('language') || '""') || navigatorLanguage || 'en';
    const locale = APP_LANGS[language] || APP_LANGS['en'];
    router.app.setLocale(APP_LANGS[locale]);

    // 国际化title
    const meta = route.meta || {};
    const theme = store.state.theme || 'light';
    if (theme === 'dark') {
      document.body.className = 'dark';
    } else {
      document.body.className = meta.backgroundClass || '';
    }

    const titleKey = `cfmoto.router.title["${route.name}"]`;
    const title = router.app.$i18n.global.t(titleKey);
    const newTitleKey = meta.translateKey || '';
    const newTitle = router.app.$i18n.global.t(newTitleKey);
    console.log(newTitle);
    store.commit(SET_TITLE, title === titleKey ? newTitle : title);
  } catch (error) {
    throw new Error(error);
  }
});

// router.onError(vueRouterError);

const { push, replace, back, go } = router;
const pattern = /\/(index.html)?#\//;
router.go = function nativeBack(options) {
  const originCurrent = (window.history.state || {}).current || '';
  const current = originCurrent.replace(pattern, '/');
  go.apply(this, [options]);
  setTimeout(() => {
    const originBackCurrent = (window.history.state || {}).current || '';
    const backCurrent = originBackCurrent.replace(pattern, '/');
    if (current === backCurrent && window.cfmoto.isNativeEnv) {
      window.cfmoto.navigateBack({ delta: 1 });
    }
  }, 10);
};

/* eslint-disable no-proto */
router.back = function nativeBack(options) {
  const originCurrent = (window.history.state || {}).current || '';
  const current = originCurrent.replace(pattern, '/');
  back.apply(this, [options]);
  setTimeout(() => {
    const originBackCurrent = (window.history.state || {}).current || '';
    const backCurrent = originBackCurrent.replace(pattern, '/');
    if (current === backCurrent && window.cfmoto.isNativeEnv) {
      window.cfmoto.navigateBack({ delta: 1 });
    }
  }, 10);
};
router.push = function nativePush(options) {
  console.log(options);
  // const routeOptions = JSON.parse(JSON.stringify(options));
  const newOptions = this.resolve(JSON.parse(JSON.stringify(options)));
  const { params, query, meta } = newOptions;
  console.log(meta);
  const token = JSON.parse(window.localStorage.getItem('token ') || '""');
  // 小程序发送token更换再切换路由
  if (isMiniProgram() && meta.miniUrl) {
    const appData = { type: 'changeToken', data: { token } };
    const queryStr = queryStringify({ ...JSON.parse(JSON.stringify(params)), ...JSON.parse(JSON.stringify(query)) });
    window.wx.miniProgram.postMessage(JSON.stringify(appData));
    window.wx.miniProgram.navigateTo({ url: `${meta.miniUrl}${queryStr ? `?${queryStr}` : ''}` });
    return;
  }
  if (window.cfmoto.isNativeEnv && meta.appName) {
    const queryData = { ...JSON.parse(JSON.stringify(params)), ...JSON.parse(JSON.stringify(query)) };
    window.cfmoto.navigateTo({ url: meta.appName, query: queryData });
    return;
  }
  console.log('push:', options);
  return push.apply(this, [options]);
};

router.replace = function nativeReplace(options) {
  console.log(options);
  // const routeOptions = JSON.parse(JSON.stringify(options));
  const newOptions = this.resolve(JSON.parse(JSON.stringify(options)));
  const { params, query, meta } = newOptions;
  const token = JSON.parse(window.localStorage.getItem('token ') || '""');
  // 小程序发送token更换再切换路由
  if (isMiniProgram() && meta.miniUrl) {
    const appData = { type: 'changeToken', data: { token } };
    const queryStr = queryStringify({ ...JSON.parse(JSON.stringify(params)), ...JSON.parse(JSON.stringify(query)) });
    window.wx.miniProgram.postMessage(JSON.stringify(appData));
    window.wx.miniProgram.navigateTo({ url: `${meta.miniUrl}${queryStr ? `?${queryStr}` : ''}` });
    return;
  }
  if (window.cfmoto.isNativeEnv && meta.appName) {
    const queryData = { ...JSON.parse(JSON.stringify(params)), ...JSON.parse(JSON.stringify(query)) };
    window.cfmoto.redirectTo({ url: meta.appName, query: queryData });
    return;
  }
  return replace.apply(this, [options]);
};

const install = router.install;

router.install = function install2(app) {
  router.app = app;
  install.apply(this, [app]);
};
// 路由
export default router;
